import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import "./FilterModal.css";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import { DISTANCES } from "../../Common/Common";
import MultiSelectModal from "./MultiSelectModal";
import AlertModal from "./AlertModal";
// import Common from "../../Common/Common";

const FilterModal = (props) => {
  const dispatch = useDispatch();
  let FilterFavorites = useSelector((state) => state.FilterFavorites);
  let FilterVisited = useSelector((state) => state.FilterVisited);
  let FilterNotVisited = useSelector((state) => state.FilterNotVisited);
  let FilterMustSee = useSelector((state) => state.FilterMustSee);
  let FilterBucketList = useSelector((state) => state.FilterBucketList);
  let FilterSearched = useSelector((state) => state.FilterSearched);
  let PlacesFilter = useSelector((state) => state.PlacesFilter);
  let GroupsFilter = useSelector((state) => state.GroupsFilter);
  let GroupsHide = useSelector((state) => state.GroupsHide);

  let CategoriesFilter = useSelector((state) => state.CategoriesFilter);
  let DistanceFilter = useSelector((state) => state.DistanceFilter);

  let ShowHiddenPlaces = useSelector((state) => state.ShowHiddenPlaces);
  let SchedulesFilter = useSelector((state) => state.SchedulesFilter);
  let DatesFilter = useSelector((state) => state.DatesFilter);
  let noFiltering = useSelector((state) => state.noFiltering);
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let ScheduleNames = useSelector((state) => state.ScheduleNames);

  let MultiselectItems = useSelector((state) => state.MultiselectItems);
  let MultiselectSelectedItems = useSelector((state) => state.MultiselectSelectedItems);
  let MultiselectMode = useSelector((state) => state.MultiselectMode);
  let MultiselectSearchText = useSelector((state) => state.MultiselectSearchText);
  let MultiselectTitle = useSelector((state) => state.MultiselectTitle);
  let MultiselectCallback = useSelector((state) => state.MultiselectCallback);
  let ShowMultiselect = useSelector((state) => state.ShowMultiselect);
  let PlaceTypeFilter = useSelector((state) => state.PlaceTypeFilter);
  let CitiesFilter = useSelector((state) => state.CitiesFilter);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);

  // const noFiltering =
  //   FilterFavorites === false &&
  //   FilterSearched === "all" &&
  //   FilterMustSee === false &&
  //   ShowHiddenPlaces === false &&
  //   FilterVisited === false &&
  //   FilterNotVisited === false &&
  //   SchedulesFilter.length === 0 &&
  //   DatesFilter.length === 0 &&
  //   PlacesFilter.length === 0 &&
  //   GroupsFilter.length === 0 &&
  //   GroupsHide.length === 0 &&
  //   CategoriesFilter.length === 0 &&
  //   DistanceFilter === -1;

  function handleFilter(FilterBy) {
    switch (FilterBy) {
      case "Only Favorites":
        dispatch(slice1Actions.SetFilterFavorites({ value: !FilterFavorites }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Only Visited":
        dispatch(slice1Actions.SetFilterVisited({ value: !FilterVisited }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Only Not Visited":
        dispatch(slice1Actions.SetFilterNotVisited({ value: !FilterNotVisited }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Only Must See":
        dispatch(slice1Actions.SetFilterMustSee({ value: !FilterMustSee }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Only Bucket List":
        dispatch(slice1Actions.SetFilterBucketList({ value: !FilterBucketList }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Only Search Results":
        if (FilterSearched !== "only_search") dispatch(slice1Actions.SetFilterSearched({ value: "only_search" }));
        else dispatch(slice1Actions.SetFilterSearched({ value: "all" }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Filter by Days":
        filterByDates();
        break;
      case "Filter by Schedules":
        FilterBySchedules();
        break;
      case "Filter by Places":
        filterByPlaces();
        break;
      case "Filter by Groups":
        filterByGroups();
        break;
      case "Filter by Categories":
        filterByCategories();
        break;
      case "Filter by Distance":
        filterByDistance();
        break;
      case "Filter by City":
        filterByCity();
        break;
      case "Hide Search Results":
        if (FilterSearched !== "no_search") dispatch(slice1Actions.SetFilterSearched({ value: "no_search" }));
        else dispatch(slice1Actions.SetFilterSearched({ value: "all" }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Hide Specific Groups":
        hideByGroups();
        break;
      case "Show Hidden Places":
        dispatch(slice1Actions.SetShowHiddenPlaces({ value: !ShowHiddenPlaces }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      case "Filter by Place type":
        filterByPlaceType();
        break;
      case "Show All":
        dispatch(slice1Actions.ClearAllFilters());
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        break;
      default:
        break;
    }
    props.onHide();
  }

  const filterByPlaceType = () => {
    const options = [
      { name: "Location", label: "Location", value: "Icon" },
      { name: "Path", label: "Path", value: "PolyLine" },
      { name: "Area", label: "Area", value: "Polygon" },
    ];
    dispatch(slice1Actions.setMultiselectCallback({ value: filterByPlaceTypeCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: options }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: PlaceTypeFilter }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Place Type" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const filterByPlaceTypeCallBack = (types) => {
    dispatch(slice1Actions.setPlaceTypeFilter({ value: types }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const filterByDates = () => {
    let _ChooseDatesList = window.guide_obj.getChooseDatesList(ScheduleName);
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterDatesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: _ChooseDatesList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: DatesFilter }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Dates" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const FilterDatesCallBack = (days) => {
    dispatch(slice1Actions.SetDatesFilter({ value: days }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const FilterBySchedules = () => {
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterBySchedulesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: ScheduleNames }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: SchedulesFilter }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Schedules" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const FilterBySchedulesCallBack = (schedules) => {
    dispatch(slice1Actions.SetSchedulesFilter({ value: schedules }));
    if (schedules.length === 1) dispatch(slice1Actions.setScheduleName({ value: schedules[0].label }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const filterByPlaces = () => {
    //console.log("filterByPlaces1");
    let places = [];
    if (PlacesFilter != null) {
      PlacesFilter.forEach((place) => {
        places.push({ label: place.Name, value: place });
      });
    }
    let _ChoosePlacesList = window.guide_obj.places.getChoosePlacesList(GuideSettings.hide_hidden);
    //console.log("_ChoosePlacesList", _ChoosePlacesList);
    //console.log("places", places);
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterPlacesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: _ChoosePlacesList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: places }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Places" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
    //console.log("filterByPlaces4");
  };

  const FilterPlacesCallBack = (_places) => {
    //console.log("FilterPlacesCallBack", _places);
    let places = [];
    if (_places != null) {
      _places.forEach((place) => {
        places.push(place.value);
      });
    }
    //console.log("FilterPlacesCallBack", places);
    dispatch(slice1Actions.SetPlacesFilter({ value: places }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const filterByGroups = () => {
    let _ChooseGroupsList = window.guide_obj.getGroupsToDisplay(null, true);
    let groupsObjArray = window.guide_obj.groupObjectArrayFromIDArray(GroupsFilter);
    let _selectedItems = [];
    for (let i = 0; i < groupsObjArray.length; i++) {
      _selectedItems.push({
        id: groupsObjArray[i].id,
        name: groupsObjArray[i].name,
        label: groupsObjArray[i].name,
        value: groupsObjArray[i],
      });
    }
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterGroupsCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: _ChooseGroupsList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: _selectedItems }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Groups" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const FilterGroupsCallBack = (groups) => {
    //console.log("FilterGroupsCallBack", groups);
    let filterList = [];
    groups.forEach((group) => {
      filterList.push(group.value.id);
    });
    dispatch(slice1Actions.SetGroupsFilter({ value: filterList }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const filterByCategories = () => {
    let _ChooseCategoriesList = window.guide_obj.getCategoriesToDisplay(null, true);
    let categoriesObjArray = window.guide_obj.categoryObjectArrayFromIDArray(CategoriesFilter);
    let _selectedItems = [];
    for (let i = 0; i < categoriesObjArray.length; i++) {
      _selectedItems.push({
        id: categoriesObjArray[i].id,
        name: categoriesObjArray[i].name,
        label: categoriesObjArray[i].name,
        value: categoriesObjArray[i],
      });
    }
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterCategoriesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: _ChooseCategoriesList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: _selectedItems }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Categories" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const FilterCategoriesCallBack = (categories) => {
    let filterList = [];
    categories.forEach((category) => {
      filterList.push(category.value.id);
    });
    dispatch(slice1Actions.SetCategoriesFilter({ value: filterList }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const filterByDistance = () => {
    let distancesList = [];
    let id = 0;
    DISTANCES.forEach((distance) => {
      distancesList.push({
        label: `${distance.toString()} km/${(distance * 0.621371).toFixed(2)} mi`,
        value: distance,
        id: (id++).toString(),
      });
    });
    let selectedDistance = [];
    if (DistanceFilter !== -1)
      selectedDistance = [
        {
          label: `${DistanceFilter.toString()} km/${(DistanceFilter * 0.621371).toFixed(2)} mi`,
          value: DistanceFilter,
        },
      ];
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterDistanceCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: distancesList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: selectedDistance }));
    dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Distance" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const FilterDistanceCallBack = (ret) => {
    if (ret.length === 0) return;
    dispatch(slice1Actions.SetDistanceFilter({ value: ret[0].value }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const filterByCity = () => {
    const allPlaces = window.guide_obj.places.placesList;
    const citySet = new Set();
    allPlaces.forEach((p) => { if (p.City) citySet.add(p.City); });
    const cityList = [...citySet].sort().map((c) => ({ label: c, value: c, id: c }));
    const selectedItems = CitiesFilter.map((c) => ({ label: c.value, value: c.value, id: c.value }));
    dispatch(slice1Actions.setMultiselectCallback({ value: FilterCityCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: cityList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: selectedItems }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Cities" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const FilterCityCallBack = (cities) => {
    dispatch(slice1Actions.SetCitiesFilter({ value: cities.map((c) => ({ value: c.value })) }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const hideByGroups = () => {
    let _ChooseGroupsList = window.guide_obj.getGroupsToDisplay(null, true);
    let groupsObjArray = window.guide_obj.groupObjectArrayFromIDArray(GroupsHide);
    let _selectedItems = [];
    for (let i = 0; i < groupsObjArray.length; i++) {
      _selectedItems.push({
        id: groupsObjArray[i].id,
        name: groupsObjArray[i].name,
        label: groupsObjArray[i].name,
        value: groupsObjArray[i],
      });
    }
    dispatch(slice1Actions.setMultiselectCallback({ value: HideGroupsCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: _ChooseGroupsList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: _selectedItems }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Groups" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const HideGroupsCallBack = (groups) => {
    let filterList = [];
    groups.forEach((group) => {
      filterList.push(group.value.id);
    });
    dispatch(slice1Actions.SetGroupsHide({ value: filterList }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };

  const displayMenuInfo = (menu_item_info) => {
    myAlert(menu_item_info, "Info");
  };

  const filterItems = [
    { label: "Show All",             key: "Show All",             active: noFiltering,                   info: "Remove all filters and show all places (except hidden)" },
    "sep",
    { label: "Only Favorites",      key: "Only Favorites",      active: FilterFavorites,                  info: "Only show the places marked as 'Favorites'" },
    { label: "Only Visited",        key: "Only Visited",        active: FilterVisited,                    info: "Only show the places marked as 'Visited'" },
    { label: "Only Not Visited",    key: "Only Not Visited",    active: FilterNotVisited,                 info: "Only show the places NOT marked as 'Visited'" },
    { label: "Only Must See",       key: "Only Must See",       active: FilterMustSee,                    info: "Only show the places marked as 'Must See'" },
    { label: "Only Bucket List",    key: "Only Bucket List",    active: FilterBucketList,                 info: "Only show the places marked as 'Bucket List'" },
    { label: "Only Search Results", key: "Only Search Results", active: FilterSearched === "only_search", info: "Only show search results. Makes it easier to see them." },
    "sep",
    { label: "Filter by Days",       key: "Filter by Days",       active: DatesFilter.length !== 0,      info: "Only show the places scheduled for selected dates" },
    { label: "Filter by Schedules",  key: "Filter by Schedules",  active: SchedulesFilter.length !== 0,  info: "Only show the places scheduled for the selected schedule" },
    { label: "Filter by Places",     key: "Filter by Places",     active: PlacesFilter.length !== 0,     info: "Only show the selected places" },
    { label: "Filter by Place type", key: "Filter by Place type", active: PlaceTypeFilter.length !== 0,  info: "Only show places of a selected type: Location, Path or Area" },
    { label: "Filter by Groups",     key: "Filter by Groups",     active: GroupsFilter.length !== 0,     info: "Only show the places that belong to the selected groups" },
    { label: "Filter by Categories", key: "Filter by Categories", active: CategoriesFilter.length !== 0, info: "Only show the places that belong to the selected categories" },
    { label: "Filter by Distance",   key: "Filter by Distance",   active: DistanceFilter !== -1,         info: "Only show the places within a specified distance" },
    { label: "Filter by City",       key: "Filter by City",       active: CitiesFilter.length !== 0,     info: "Only show the places in the selected cities" },
    "sep",
    { label: "Hide Specific Groups", key: "Hide Specific Groups", active: GroupsHide.length !== 0,       info: "Don't show places that belong to the selected groups" },
    { label: "Hide Search Results",  key: "Hide Search Results",  active: FilterSearched === "no_search", info: "Hide all search results from the places list" },
    { label: "Show Hidden Places",   key: "Show Hidden Places",   active: ShowHiddenPlaces,              info: "Show hidden places. Hidden places are kept hidden to reduce clutter." },
  ];

  if (ShowMultiselect)
    return (
      <MultiSelectModal
        show={ShowMultiselect}
        onHide={() => dispatch(slice1Actions.setShowMultiselect({ value: false }))}
        MultiselectItems={MultiselectItems}
        MultiselectSelectedItems={MultiselectSelectedItems}
        MultiselectMode={MultiselectMode}
        MultiselectCallback={MultiselectCallback}
        MultiselectTitle={MultiselectTitle}
        MultiselectSearchText={MultiselectSearchText}
      />
    );
  return (
      <div className="modal">
        <Modal
          size="sm"
          {...props}
          dialogClassName="myModalClass fm-dialog"
          aria-labelledby="fm-title"
          centered
          scrollable={false}
          onHide={props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="fm-shell">
              <div className="fm-header">
                <div className="fm-header-icon">
                  <FontAwesomeIcon icon={solid("filter")} />
                </div>
                <h2 className="fm-title" id="fm-title">Places Filter</h2>
                <button className="fm-close" onClick={props.onHide} aria-label="Close">
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              <div className="fm-list">
                {filterItems.map((item, i) => {
                  if (item === "sep") return <div key={`sep${i}`} className="fm-separator" />;
                  return (
                    <div key={item.key} className="fm-item" onClick={() => handleFilter(item.key)}>
                      <div className={`fm-check${item.active ? " active" : ""}`}>
                        {item.active && <FontAwesomeIcon icon={solid("check")} />}
                      </div>
                      <span className="fm-label">{item.label}</span>
                      <button
                        className="fm-info-btn"
                        title={item.info}
                        onClick={(e) => { e.stopPropagation(); displayMenuInfo(item.info); }}
                        aria-label={`Info: ${item.label}`}
                      >
                        <FontAwesomeIcon icon={solid("info")} />
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      </div>
    );
};

export default FilterModal;
